module.exports = __webpack_public_path__ + "static/media/google-play-naranja.d33f3646.svg";